/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  GetL2DepthOptions,
  GetL2DepthStatus200,
  GetL2DepthStatus400,
  GetL2DepthStatus404,
  GetL2DepthStatus500,
} from '../types/GetL2Depth'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { getL2Depth } from '../clients/getL2Depth'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getL2DepthQueryKey = ({ path }: Omit<GetL2DepthOptions, 'headers'>) =>
  [{ url: '/v1/orderbooks/:order_book_id/L2', params: path }] as const

type GetL2DepthQueryKey = ReturnType<typeof getL2DepthQueryKey>

export function getL2DepthQueryOptions(
  { path }: GetL2DepthOptions,
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const queryKey = getL2DepthQueryKey({ path })
  return queryOptions<
    GetL2DepthStatus200,
    ResponseErrorConfig<GetL2DepthStatus400 | GetL2DepthStatus404 | GetL2DepthStatus500>,
    GetL2DepthStatus200,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getL2Depth({
        ...config,
        path,
        signal: config.signal ?? signal,
        throwOnError: true,
      }).unwrap()
    },
  })
}

/**
 * @summary Get the aggregated price levels for a specific orderbook (L2 market depth)
 * {@link /v1/orderbooks/:order_book_id/L2}
 */
export function useGetL2Depth<
  TData = GetL2DepthStatus200,
  TQueryData = GetL2DepthStatus200,
  TQueryKey extends QueryKey = GetL2DepthQueryKey,
>(
  { path }: { path: GetL2DepthOptions['path'] | (() => GetL2DepthOptions['path']) },
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetL2DepthStatus200,
        ResponseErrorConfig<GetL2DepthStatus400 | GetL2DepthStatus404 | GetL2DepthStatus500>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const resolvedParams = { path: typeof path === 'function' ? path() : path }
  const queryKey = resolvedOptions?.queryKey ?? getL2DepthQueryKey(resolvedParams)

  const queryResult = useQuery(
    {
      ...getL2DepthQueryOptions(resolvedParams, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<GetL2DepthStatus400 | GetL2DepthStatus404 | GetL2DepthStatus500>
  > & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
